import React, { Component } from "react"
import EditableTableHolder from "../components/EditableDiscountTableHolder"
import { connect } from "react-redux"
import { getAlcoholFunc } from "../ducks/alcohol"
import { withTranslation } from "react-i18next"

const columns = [
  {
    title: "Название",
    name: "productName",
    dataType: "string",
    // sortable: true,
    // editable: true,
  },
  {
    title: "Группа",
    name: "productGroup",
    dataType: "string",
    // sortable: true,
    // editable: true,
  },
  {
    title: "Объём",
    name: "volume",
    dataType: "string",
    // sortable: true,
    // editable: true,
  },
  {
    title: "Серия",
    name: "series",
    dataType: "string",
    // sortable: true,
    // editable: true,
  },
  {
    title: "Проверка",
    name: "isVerified",
    dataType: "string",
    render: (rowData) =>
      rowData.isVerified ? "Проверка пройдена" : "Проверка не пройдена",
    // sortable: true,
    // editable: true,
  },
]
@withTranslation()
@connect(
  (state) => ({
    data: state.alkashka.alcohol,
    totalCount: state.alkashka.totalCount,
    okAlco: state.alkashka.okAlco,
    palyonka: state.alkashka.palyonka,
  }),
  (dispatch) => ({
    getAlcohol: (code) => dispatch(getAlcoholFunc(code)),
  }),
)
class UkmPage extends Component {
  lastKeyTime = 0
  componentDidMount() {
    document.body.addEventListener("keypress", this.tryPip, false)
  }

  componentWillUnmount() {
    document.body.removeEventListener("keypress", this.tryPip, false)
  }

  tryPip = (event) => {
    const timeStamp = Date.now()
    const { code, key } = event
    if (timeStamp - this.lastKeyTime > 300) {
      this.newBarcode = key
    } else {
      if (code.startsWith("Digit") || code.startsWith("Key")) {
        this.newBarcode += key
      } else {
        if (key === "Enter") {
          this.props.getAlcohol(this.newBarcode)
        }
        this.newBarcode = ""
      }
    }
    this.lastKeyTime = timeStamp
  }

  render() {
    const { data, totalCount, okAlco, palyonka } = this.props
    const tableData = {
      columns,
      data,
    }
    return (
      <div>
        <EditableTableHolder
          title="УКМ"
          info="Учетно-контрольная марка"
          tableData={tableData}
          noOptions
          totalCount={totalCount}
          okAlco={okAlco}
          palyonka={palyonka}
          // button={true}
        />
      </div>
    )
  }
}

export default UkmPage
